/**
 * Kindred & Kin — Inline Search Predictive Results
 */
(function () {
  const DEBOUNCE_MS = 300;
  const MIN_CHARS = 2;

  const BRAND_MAP = [
    { terms: ['benamor', 'benamôr'],          handle: 'benamor-lisbon-1925', min: 6 },
    { terms: ['castelbel'],                    handle: 'castelbel',           min: 6 },
    { terms: ['portus cale', 'portus'],        handle: 'portus-cale',         min: 6 },
    { terms: ['vista alegre'],                 handle: 'vista-alegre',        min: 5 },
    { terms: ['bombchel'],                     handle: 'bombchel',            min: 7 },
    { terms: ['bathorium'],                    handle: 'bathorium',           min: 6 },
    { terms: ['brooklyn tea', 'brooklyn'],     handle: 'ritual-teas',         min: 8 },
    { terms: ['fair trade egypt'],             handle: 'fair-trade-egypt',    min: 9 },
    { terms: ['belart'],                       handle: 'belart-fair-trade',   min: 5 },
    { terms: ['kosta boda'],                   handle: 'kosta-boda',          min: 9 },
    { terms: ['dakar market', 'dakar'],        handle: 'dakar-market-edit',   min: 5 }
  ];

  function debounce(fn, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  function getCollectionUrl(query) {
    const q = query.toLowerCase().trim();
    for (const brand of BRAND_MAP) {
      if (q.length < brand.min) continue;
      for (const term of brand.terms) {
        if (term.startsWith(q) || q === term) {
          return '/collections/' + brand.handle;
        }
      }
    }
    return theme.routes.search_url + '?q=' + encodeURIComponent(query);
  }

  function buildSeeAllFooter(query) {
    const url = getCollectionUrl(query);
    const footer = document.createElement('div');
    footer.className = 'thb-inline-search-dropdown__footer';
    footer.innerHTML = `<a href="${url}" class="thb-inline-search-dropdown__see-all">See all results for &ldquo;${query}&rdquo; &rarr;</a>`;
    return footer;
  }

  function init() {
    const form = document.querySelector('.thb-inline-search');
    if (!form) return;

    const input = form.querySelector('.thb-inline-search__input');
    if (!input) return;

    const dropdown = document.createElement('div');
    dropdown.className = 'thb-inline-search-dropdown';
    form.parentNode.insertBefore(dropdown, form.nextSibling);

    const fetchResults = debounce(function (query) {
      if (query.length < MIN_CHARS) { closeDropdown(); return; }

      dropdown.classList.add('thb-inline-search-dropdown--loading');

      fetch(
        `${theme.routes.predictive_search_url}?q=${encodeURIComponent(query)}&${encodeURIComponent('resources[type]')}=product,article,query,page&${encodeURIComponent('resources[limit]')}=6&resources[options][fields]=title,product_type,vendor,variants.title,variants.sku&section_id=predictive-search`
      )
        .then((res) => { if (!res.ok) throw new Error(res.status); return res.text(); })
        .then((text) => {
          const parsed = new DOMParser().parseFromString(text, 'text/html');
          const section = parsed.querySelector('#shopify-section-predictive-search');
          if (!section) return;

          dropdown.innerHTML = '';
          const results = document.createElement('div');
          results.className = 'thb-inline-search-dropdown__results';
          results.innerHTML = section.innerHTML;

          const suggestions = results.querySelector('.search-results--suggestions');
          if (suggestions) suggestions.remove();

          dropdown.appendChild(results);
          dropdown.appendChild(buildSeeAllFooter(query));
          dropdown.classList.remove('thb-inline-search-dropdown--loading');
          dropdown.classList.add('thb-inline-search-dropdown--open');
        })
        .catch(() => { dropdown.classList.remove('thb-inline-search-dropdown--loading'); });
    }, DEBOUNCE_MS);

    function closeDropdown() {
      dropdown.classList.remove('thb-inline-search-dropdown--open');
      dropdown.innerHTML = '';
    }

    input.addEventListener('input', function () {
      const query = input.value.trim();
      if (!query.length) { closeDropdown(); return; }
      fetchResults(query);
    });

    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape') closeDropdown();
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target) && !dropdown.contains(e.target)) closeDropdown();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();